<template>
  <div>
    <v-layout align-center class="subheading pl-3 pr-3 crx-toolbar">
      <div class="mt-2 mb-2">
        Deliveries
      </div>
      <v-spacer></v-spacer>
      <v-menu offset-y
      :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
            text
            v-on="on"
          >
            <span >{{ ((page - 1) * rowsPerPage) + 1 }}-{{ Math.min(page * rowsPerPage, searchMatches.length) }} of {{ searchMatches.length }}</span>
          </v-btn>
        </template>
        <v-card class="pa-2">
          <span class="caption">Items per page</span>
          <v-text-field
          v-model="rowsPerPageTV"
          hide-details
          style="max-width: 70px;"
          solo></v-text-field>
        </v-card>
      </v-menu>
    </v-layout>

    <v-layout wrap>
      <v-flex xs12
      v-for="delivery in paginatedArray" 
      :key="delivery.id">
        <delivery-card
        @click.native="$router.push('/delivery/' + delivery.id)"
        :id="delivery.id"
        :inventoryItemId="id">
        </delivery-card>
      </v-flex>
    </v-layout>

    <div class="text-xs-center">
      <v-pagination
      v-if="paginationLength > 1"
      v-model="page"
      :length="paginationLength"
      circle>

      </v-pagination>

    </div>

  </div>
</template>

<script>
import DeliveryCard from './DeliveryCard'
import ListController from '@/mixins/ListController'

export default {
  props: ['id'],
  components: {
    DeliveryCard
  },
  mixins: [ListController],
  data () {
    return {
      // 7
    }
  },
  computed: {
    itemsSource () {
      var deliveryItems = Object.values(this.$store.state.db.deliveryItems.items)
      var uniqueIdTracker = []
      return deliveryItems.reduce((a, i) => {
        if (i.inventory_item_id === parseInt(this.id) && !uniqueIdTracker.includes(i.delivery_id)) {
          a.push(this.$store.state.db.deliveries.deliveries[i.delivery_id])
          uniqueIdTracker.push(i.delivery_id)
        }
        return a
      }, [])
    },
  },
  methods: {
    sync () {
      this.items = JSON.parse(JSON.stringify(this.itemsSource))
    },
    sort (headerIndex, items, sortAscending) {
      if (headerIndex === 0) { // date
        return items.sort((a, b) => {
          return sortAscending ? new Date(a.date) - new Date(b.date) : new Date(b.date) - new Date(a.date)
        })
      }
    },
  },
  mounted () {
    this.sync()
  }
}
</script>
